import { jsx } from "react/jsx-runtime";
import { bool, node, number, string, arrayOf, oneOf, oneOfType, func } from "prop-types";
import React, { Children, cloneElement, useEffect, useState } from "react";
import cx from "classnames";
const propTypes = {
  /** Required children of type `ChoiceItem` */
  children: oneOfType([
    /** Array of elements used as children. */
    arrayOf(node),
    /** One or more elements without array. */
    node
  ]).isRequired,
  /** Sets default selected `ChoiceItem` by index */
  preselectedIndex: number,
  /** Choice selection style, overrides any children `subtle` property */
  subtle: bool,
  /** Determines the size of the ChoiceItems */
  size: oneOf(["small", "medium", "large"]),
  /** `ChoiceItem` can be deselected */
  deselectable: bool,
  /** Can be used to add classes to base HTML element. */
  className: string,
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Callback invoked after selection. */
  onSelect: func
};
const Choice = (props) => {
  const {
    preselectedIndex,
    prefix = "",
    subtle,
    size = "large",
    children,
    deselectable,
    className,
    onSelect,
    ...other
  } = props;
  const childrenArray = Children.toArray(children);
  const [selectedItem, setSelectedItem] = useState(childrenArray[preselectedIndex] && childrenArray[preselectedIndex].props.id);
  const onChoiceSelect = (id) => {
    const isSelected = selectedItem === id;
    const currentItem = isSelected && deselectable ? null : id;
    setSelectedItem(currentItem);
    return onSelect && onSelect(currentItem);
  };
  useEffect(() => {
    setSelectedItem(childrenArray[preselectedIndex] && childrenArray[preselectedIndex].props.id);
  }, [preselectedIndex]);
  const baseClass = `${prefix}choice`;
  const listClasses = cx(
    baseClass,
    `${baseClass}--${size}`,
    className
  );
  return /* @__PURE__ */ jsx(
    "ul",
    {
      className: listClasses,
      ...other,
      children: childrenArray.map((child, i) => {
        const key = child.key || i;
        const isSelected = selectedItem === child.props.id;
        return /* @__PURE__ */ jsx("li", { className: `${baseClass}__list-item`, children: cloneElement(child, {
          selected: isSelected,
          onClick: (...args) => {
            onChoiceSelect(...args);
            if (child.props.onClick)
              child.props.onClick(...args);
          },
          subtle,
          size
        }) }, key);
      })
    }
  );
};
Choice.propTypes = propTypes;
var Choice_default = Choice;
export {
  Choice_default as default
};
